import type { ColumnDef } from "@tanstack/react-table";
import { RTKQueryErrorAlert } from "@/shared/components/domain/errors/rtk-query-error-alert";
import {
  DataTable,
  DataTableContainer,
  useDataTableController,
} from "@/shared/components/data-table";
import { DeliveryViewModel } from "@/services/backend/sample-set/sample-set";
import { useListDeliveryViewModelQuery } from "@/services/backend/sample-set/service";
import {
  procedureTypes,
  samplingMethods,
} from "@/shared/components/enum-labels";

const createTableColumns = (): ColumnDef<DeliveryViewModel>[] => [
  {
    id: "samplingMethod",
    accessorKey: "samplingMethod",
    header: "Methode",
    cell: ({ row }) => {
      const sampleSetData = row.original;
      return samplingMethods[sampleSetData.samplingMethod];
    },
  },
  {
    id: "procedureType",
    accessorKey: "procedureType",
    header: "Prüfverfahren",
    cell: ({ row }) => {
      const sampleSetData = row.original;
      return procedureTypes[sampleSetData.procedureType];
    },
  },
  {
    id: "Caso",
    accessorKey: "casoCount",
    header: "Caso",
    cell: ({ row }) => {
      const sampleSetData = row.original;
      return sampleSetData.casoCount;
    },
  },
  {
    id: "MEA",
    accessorKey: "meaCount",
    header: "MEA",
    cell: ({ row }) => {
      const sampleSetData = row.original;
      return sampleSetData.meaCount;
    },
  },
  {
    id: "DG18",
    accessorKey: "DG18Count",
    header: "DG18",
    cell: ({ row }) => {
      const sampleSetData = row.original;
      return sampleSetData.DG18Count;
    },
  },
];

interface SampleSetTableProps {
  deliveryId: string;
}

export function SampleSetTable({ deliveryId }: SampleSetTableProps) {
  const {
    data: list,
    isLoading,
    isFetching,
    error,
  } = useListDeliveryViewModelQuery(
    { deliveryId },
    {
      refetchOnMountOrArgChange: true,
    },
  );

  const cols = createTableColumns();
  const table = useDataTableController(cols, list?.data || []);

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  return (
    <div className="flex w-full flex-col space-y-4">
      <DataTableContainer className="w-full">
        <DataTable
          table={table}
          columns={cols}
          isLoading={isLoading || isFetching}
        />
      </DataTableContainer>
    </div>
  );
}
